import Images from "../../../../assets/js/Images";

export const data1 = [
  {
    image: Images?.about1,
    count: "1000 +",
    title: "Our Specialists",
    subtitle: "Bring to the table win-win strategies to ensure proactive domination.",
  },
  {
    image: Images?.about2,
    count: "300 +",
    title: "Worldwide Presence",
    subtitle: "Bring best quality health services to ones who are in need worldwide.",
  },
  {
    image: Images?.about3,
    count: "35000 +",
    title: "Satisfied Members",
    subtitle: "We love to call our members our family for whom we are always there to help the way best we can.",
  },
]

export const steps = [
  {
    name: "Our Vision",
    value: "ourVision",
  },
  {
    name: "Community",
    value: "community",
  },
  {
    name: "How to start your care ?",
    value: "start",
  },
]

export const data2 = [
  {
    title: "Choose a Plan",
    subtitle: "Call and speak to one of our friendly team who will discuss the application process and set a schedule for checkups"
  },
  {
    title: "Search for the Experienced Mental Health Counselors, Alternative Medicine Specialists or Meditation Teachers",
    subtitle: "Request a home visit where we will provide you with a thorough checkups, deep analysis and detailed plan."
  },
  {
    title: "Schedule an Appointment",
    subtitle: "Once agreed, we will start your care package and introduce you to your caregiver as soon as possible."
  },
]